<template>
    <v-layout fill-height :class="$vuetify.breakpoint.xsOnly ? 'main-mobile px-5 template-padding' : 'main template-padding'">
        <v-container :class="$vuetify.breakpoint.xsOnly ? 'inner-container my-5 pb-15' : 'inner-container my-15 px-10'">
            <div v-for="(item, itemIndex) in items" :key="itemIndex">

                <template v-if="item.type == 'banner'">

                    <v-container :class="outerContainer">
                        <div
                            class="fredoka"
                            :class="$vuetify.breakpoint.lgAndUp ? 'h3' : 'h4'"
                            style="color: #3e1948"
                            @focusout="editableData('banner', { element: 'heading' })"
                            :contenteditable="editableContent"
                            v-html="item.heading"
                        >
                        </div>
                        <div :class="$vuetify.breakpoint.xsOnly ? 'h5' : 'h4'"
                            style="color: #3e1948"
                            @focusout="editableData('banner', { element: 'subtitle' })"
                            :contenteditable="editableContent"
                            v-html="item.subtitle"
                        >
                        </div>
                        <RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
                    </v-container>

                </template>

                <template v-if="item.type == 'grids'">
                    <Grid2 @clickedColumn="clickedColumn" :item="item" :index="itemIndex" :key="gridKey"
                        :styles="{
                            text: 'body poppins',
                            image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
                            heading1: {
                                wrapper: 'cjb-heading1 mb-5',
                                classMobile: 'h4 fredoka text-left',
                                classLarge: 'h4 fredoka text-left',
                                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
                            },
                            heading2: {
								wrapper: 'text-left mb-5 cjb-heading2',
								classMobile: 'poppins h5 font-weight-bold text-left py-5',
								classLarge: 'poppins h5 font-weight-bold text-left py-5',
								after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
							},
                            textcard: {
                                outlined: true,
                                elevation: 0,
                                card: 'cjb-card px-5 py-5 mb-3 ',
                                text: 'poppins ',
                                subtitle: ''
                            },
                            imagecard: {
                                doubleCard: false,
                                elevation: 0,
                                outlined: false,
                                card: 'poppins px-5 py-5 mb-5 text-left cjb-img-card d-flex justify-center align-center',
                                imagePosition: 'left',
                                image: {
                                    height: '150px',
                                    width: '150px'
                                },
                                text: '',
                                subtitle: '',
                                custom: {

                                },
                                settings: {
                                    colsImage: 6,
                                    colsText: 6
                                }
                            },
                             dialog: {
                                elevation: 0,
                                cardClass: 'pa-5 mt-5',
                                cardColor: '#CBD2F5',
                                innerCard: '',
                                dialogTitle: '',
                                dialogName: 'rubik font-weight-bold mr-2 responsive-text',
                                textWrapper: 'body poppins text-left responsive-text',
                                custom: {
                                    text: ''
                                }
                        }

                        }"
                    />
                </template>
            </div>

            <ImageUploader />
        </v-container>
    </v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import responsiveHeight from "@/mixins/responsiveHeight"

export default {
    props: ["items"],
    mixins: [responsiveHeight],
    components: {
        RowControls, ImageUploader, Grid2
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        }
    },
    methods: {

    }
}
</script>

<style scoped>
.main {
  background: url("../../assets/images/backgrounds/convo-jr-basic.png");
  background-size: 100% 100%;
}
.main-mobile {
  background: url("../../assets/images/backgrounds/convo-jr-basic-mobile.png");
  background-size: 100% 100%;
  padding-top: 50px;
}
.inner-container {
  background-color: #ffffff;
  border-radius: 20px;
}
</style>
